import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-light-svg-icons';

import classes from './ActionButton.module.scss';

interface ActionButtonProps {
    title: string;
    description: string;
    onClick?: () => void;
}

export const ActionButton: React.FC<ActionButtonProps> = props => {
    return (
        <button type="button" className={classes.root} onClick={props.onClick}>
            <span className={classes.content}>
                <span className={classes.title}>{props.title}</span>
                <span className={classes.description}>{props.description}</span>
            </span>

            <FontAwesomeIcon icon={faAngleRight} className={classes.icon} />
        </button>
    );
};
